import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { AppConfig } from '../providers/appconfig';
/*
  Generated class for the WebserviceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class WebServiceProvider {
  // since there are multiple  sources keep track of them
  // by using arrays of objects.
  bioWW3Objects: any = [] ;
  buoyObjects: any = [] ;
  dwwObjects: any = [] ;
  constructor(public http: Http) {
    console.log('Hello WebServiceProvider Provider');
  }

  // get the object or create a new one.
  getBioWW3Object(name) {
    let found: boolean = false ;
    for ( var eKey in this.bioWW3Objects ) {
      if ( this.bioWW3Objects[eKey].name == name ) {
        found = true;
        break;
      }
    }
    if ( !found ) {
      let newObject = new BioWW3Object(name) ;
      this.bioWW3Objects.push(newObject);
      return ( newObject ) ;
    }
  return(this.bioWW3Objects[eKey]);
  }

  // get the object or create a new one.
  getBuoyObject(name) {
    let found: boolean = false ;
    for ( var eKey in this.buoyObjects ) {
      if ( this.buoyObjects[eKey].name == name ) {
        found = true;
        break;
      }
    }
    if ( !found ) {
      let newObject = new BuoyObject(name) ;
      this.buoyObjects.push(newObject);
      return ( newObject ) ;
    }
  return(this.buoyObjects[eKey]);
  }

  // get the object or create a new one.
  getDWWObject(name) {
    let found: boolean = false ;
    for ( var eKey in this.dwwObjects ) {
      if ( this.dwwObjects[eKey].name == name ) {
        found = true;
        break;
      }
    }
    if ( !found ) {
      let newObject = new DWWObject(name) ;
      this.dwwObjects.push(newObject);
      return ( newObject ) ;
    }
  return(this.dwwObjects[eKey]);
  }
}


class BioWW3Object {

  name: string ;
  initialized: boolean = false ;
  bioww3_data: any;

  constructor( name: string) {
    this.name = name ;
  }

  getDataURL(date_start,hours_forward, location_name, data_type_name, appConfig) {
    // this reads from the gomoos bio database of ww3 forecast data
    //http://local.drupal7.neracoos.org:8082/data/export/bioww3.php?bio_site_id=Forecast%20for%20E0111&grid=E_FINE
    var queryString = '/data/export/bioww3.php?bio_site_id=' +
              location_name + '&date_start=' + date_start +
              '&hours_forward=' + hours_forward + '&grid=' + data_type_name;
    var encQS =  encodeURIComponent(queryString);
    var straightURL = 'http://' + appConfig.getNJSProxyNeracoosHostPrefix() + queryString ;

    return( straightURL );
  }

}
class BuoyObject {

  name: string ;
  initialized: boolean = false ;
  buoy_data: any;

  constructor( name: string) {
    this.name = name ; ;
  }

  getDataURL(date_start,hours_back, location_name, appConfig) {
    // this reads from the gomoos gomoos2 database of buoy data
    // http://local.drupal7.neracoos.org/data/json/buoyrecentdata.php?platform=B01&mp=no&hb=6&tsdt=significant_height_of_wind_and_swell_waves,dominant_wave_period,sea_water_temperature,sea_water_density
    var queryString = '/data/json/buoyrecentdata.php?platform=' +
              location_name +
              '&mp=no&hb=' + hours_back + '&tsdt=significant_height_of_wind_and_swell_waves,dominant_wave_period,sea_water_temperature,sea_water_density';
    var encQS =  encodeURIComponent(queryString);
    var straightURL = 'http://' + appConfig.getNJSProxyNeracoosHostPrefix() + queryString ;
    return( straightURL );
  }

}
class DWWObject {

  name: string ;
  initialized: boolean = false ;
  dww_data: any;

  constructor( name: string) {
    this.name = name ;
  }

  getDataURL(dww_start_date, dww_end_date, location_name, dww_locations, appConfig) {
    // this is a two step process now. First query the service for the location details
    // which is essentially the  lat/lon position.
    // then use that lat lon position to get the actual data
    // ALSO ask for all the locations then cache the response to this.
    // and re-use it for each inundation location.
    let dww_loc: any ;
    for ( var dww_key in dww_locations ) {
      dww_loc = dww_locations[dww_key] ;
      if ( dww_loc.monitoringlocationidentifier == location_name ) {
        break;
      }
    }
    // http://www.neracoos.org/erddap/griddap/WW3_GulfOfMaine_latest.json?hs[(2016-04-01T00:00:00Z):1:(2016-04-01T00:00:00Z)][(46.05):1:(40.05)][(-72.05):1:(-63.05)],swp[(2016-04-01T00:00:00Z):1:(2016-04-01T00:00:00Z)][(46.05):1:(40.05)][(-72.05):1:(-63.05)],dir[(2016-04-01T00:00:00Z):1:(2016-04-01T00:00:00Z)][(46.05):1:(40.05)][(-72.05):1:(-63.05)]
    var geo_array = appConfig.parseGeoLocation( dww_loc.geolocation ) ;
    var path = '/erddap/griddap/WW3_GulfOfMaine_latest.json?' ;
    // format is start step stop for both time and position.
    // data types are
    // hs significant wave height, m
    // swp (sea_surface_wave_frequency, s)
    // dir (Dominant Wave Direction, degree_true)
    // hs[(2016-04-01T00:00:00Z):1:(2016-04-01T00:00:00Z)][(46.05):1:(40.05)][(-72.05):1:(-63.05)]
    path += 'hs[(' + dww_start_date + '):1:(' + dww_end_date + ']' ;
    path += '[(' + geo_array['lat'] + '):1:(' +geo_array['lat'] + ')][(' + geo_array['lon'] + '):1:(' + geo_array['lon'] + ')]' ;
    // ,swp[(2016-04-01T00:00:00Z):1:(2016-04-01T00:00:00Z)][(46.05):1:(40.05)][(-72.05):1:(-63.05)]
    path += ',swp[(' + dww_start_date + '):1:(' + dww_end_date + ']' ;
    path += '[(' + geo_array['lat'] + '):1:(' +geo_array['lat'] + ')][(' + geo_array['lon'] + '):1:(' + geo_array['lon'] + ')]' ;
    // ,dir[(2016-04-01T00:00:00Z):1:(2016-04-01T00:00:00Z)][(46.05):1:(40.05)][(-72.05):1:(-63.05)]
    path += ',dir[(' + dww_start_date + '):1:(' + dww_end_date + ']' ;
    path += '[(' + geo_array['lat'] + '):1:(' +geo_array['lat'] + ')][(' + geo_array['lon'] + '):1:(' + geo_array['lon'] + ')]' ;

    // var plain_url = "http://www.neracoos.org" + path ;
    var encQS =  encodeURIComponent(path);
    var neracoosProxyURL = appConfig.getNeracoosHostPrefix() + '/proxy2?ajax=1&url=http://www.neracoos.org' + encQS ;

    return( neracoosProxyURL );
  }
  getNECOFSWaveURL(location_name, dww_locations, appConfig) {
    // NECOFS forecast
    // Wave
    // http://www.neracoos.org:8300/cgi-bin/necofs_query?lat=43.18&lon=-70.42&necofs_type=water_level&domain=GOM3
    let dww_loc: any ;
    for ( var dww_key in dww_locations ) {
      dww_loc = dww_locations[dww_key] ;
      if ( dww_loc.monitoringlocationidentifier == location_name ) {
        break;
      }
    }
    var geo_array = appConfig.parseGeoLocation( dww_loc.geolocation ) ;
    var necofs_wave_qs = '/cgi-bin/necofs_query?lat=' + geo_array['lat'] + '&lon=' +
            geo_array['lon'] +
           '&necofs_type=wave&domain=GOM3';
    var necofsWaveURL = "http://www.neracoos.org:8300" + necofs_wave_qs ;
    return( necofsWaveURL ) ;
  }
  getNECOFSWaveLengthURL(location_name, dww_locations, appConfig) {
    // NECOFS forecast
    // Wave
    // http://www.neracoos.org:8300/cgi-bin/necofs_query?lat=43.18&lon=-70.42&necofs_type=water_level&domain=GOM3
    let dww_loc: any ;
    for ( var dww_key in dww_locations ) {
      dww_loc = dww_locations[dww_key] ;
      if ( dww_loc.monitoringlocationidentifier == location_name ) {
        break;
      }
    }
    var geo_array = appConfig.parseGeoLocation( dww_loc.geolocation ) ;
    var necofs_wave_qs = '/cgi-bin/necofs_query?lat=' + geo_array['lat'] + '&lon=' +
            geo_array['lon'] +
           '&necofs_type=wlen&domain=GOM3';
    var necofsWaveURL = "http://www.neracoos.org:8300" + necofs_wave_qs ;
    return( necofsWaveURL ) ;
  }

}



// WEBPACK FOOTER //
// ./src/providers/webservice-provider.ts